import { render, staticRenderFns } from "./PolNoFormHelplist.vue?vue&type=template&id=cb0a4212&"
import script from "./PolNoFormHelplist.vue?vue&type=script&lang=js&"
export * from "./PolNoFormHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports